import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useProfitLossCharts(
  filters: AnalyticsFilters = {},
  options: { enabled?: boolean } = {},
) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "pnl-charts", filters],
    enabled: options.enabled ?? true,
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/pnl-charts", {
        params: {
          query: toAnalyticsQuery(filters),
        },
      });
      if (error !== undefined) {
        throw new Error("Failed to load P&L charts");
      }
      return data;
    },
  });
}
